import { useMemo } from 'react';

import {
  apps,
  sourceAccountId,
  dataClasses,
  environment,
  resourceType,
  sourceRegion,
  subnets,
  vpc,
  cloudProvider,
  resourceGroupName,
  tagKeys,
  tagKeyValues,
  sensitivityAnnotations,
} from '@/components/queryBuilder/properties';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { type FilterProperty } from '@/types/advanceFilter';

const supportedControlProperties: FilterProperty[][] = [
  [resourceType, dataClasses, environment, apps],
  [
    cloudProvider,
    sourceAccountId,
    sourceRegion,
    vpc,
    subnets,
    resourceGroupName,
  ],
  [tagKeys, tagKeyValues],
];

const supportedControlPropertiesWithSensitivityAnnotations: FilterProperty[][] =
  [
    [resourceType, dataClasses, environment, apps, sensitivityAnnotations],
    [
      cloudProvider,
      sourceAccountId,
      sourceRegion,
      vpc,
      subnets,
      resourceGroupName,
    ],
    [tagKeys, tagKeyValues],
  ];

export const useSupportedControlProperties = (): FilterProperty[][] => {
  const { SensitivityAnnotations: enableSensitivityAnnotations } =
    useFeatureFlags();

  return useMemo(
    () =>
      enableSensitivityAnnotations
        ? supportedControlPropertiesWithSensitivityAnnotations
        : supportedControlProperties,
    [enableSensitivityAnnotations]
  );
};
